import React from 'react';
import styles from './TextInput.module.css';

const TextInput = (props) => {
    const { style, name, password, placeholder, value, onChange } = props;

    return (
        <input
            className={styles.textInput}
            type={password ? "password" : "text"}
            style={style}
            name={props.name}
            placeholder={props.placeholder}
            value={value}
            onChange={onChange}
        />
    )
};

export default TextInput;
